
export interface ICountResult {
	count?: number;
}

export interface IOrganization {
	id?: string;
	externalId?: string;
	guid?: string;
	name?: string;
	description?: string;
	learnerPageAccess?: boolean;
	status?: string;
	root?: IOrganization;
	children?: IOrganization[];
	logoURL?: string;
	userCount?: ICountResult;
	entryCount?: ICountResult;
	discussionCount?: ICountResult;
}

interface IOrganizationWrapperArgs {
	organization: IOrganization;
}

export class OrganizationWrapper {

	private org: IOrganization;

	constructor(args: IOrganizationWrapperArgs) {
		this.org = args.organization || {};
	}

	public getEntryCount(): number {
		return this.org.entryCount && this.org.entryCount.count || 0;
	}

	public getDisucssionCount(): number {
		return this.org.discussionCount && this.org.discussionCount.count || 0;
	}

	public getUserCount(): number {
		return this.org.userCount && this.org.userCount.count || 0;
	}
}



// WEBPACK FOOTER //
// ./src/common/entities/organizationWrapper/OrganizationWrapper.ts